export default "__VITE_ASSET__BNOxrlw___"